import { toast } from "sonner";

// Completing a class raises the invoice as a draft while the trainer has no
// ABN on file. Without this the invoice silently "disappears" into Drafts.
export const DRAFT_ABN_MESSAGE = "Invoice saved as a draft. Add your ABN in Settings to send it.";

export const isAwaitingAbn = (inv) => !!(inv && inv.awaiting_abn);

export function toastDraftAwaitingAbn(go) {
  toast.warning(DRAFT_ABN_MESSAGE, {
    duration: 12000,
    action: {
      label: "Open Settings",
      onClick: () => (go ? go("/settings") : window.location.assign("/settings")),
    },
  });
}
